<template>
  <div class="container-fluid profile-container">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Personal Details
    </h1>
    <div class="card-section">
        <div class="row section-body">
            <div v-for="(display_name, key) in layout" class="col-sm-3 section-property-block">
                <p class="section-property-title"> {{ display_name }}</p>
                  <div @click="enable(key)">
                    <input v-model="model[key]" :disabled="true" :id="key" type="text" class="section-property" :placeholder="user[key]">
                  </div>
            </div>
        </div>
    </div>

    <div class="card-section">
         <h1 class="section-title">Credentials</h1>
        <div class="row section-body">
            <div v-for="(display_name, key) in passwordLayout" class="col-sm-3 section-property-block">
                <p class="section-property-title"> {{ display_name }}</p>
                  <div @click="enable(key)">
                    <input v-model="model[key]" :id="key" type="password" class="section-property" :placeholder="user[key]">
                  </div>
            </div>
        </div>
    </div>
    <!-- drop the thingy here -->
    <div class="row">
        <div class="col-sm-2"><btn @click="update()" size="lg" type="primary">Update</btn></div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import $ from 'jquery';
import { bus } from '../../main';
import constants  from '../../constants.js';
import GenericUpdateCreate from '../../api.js';
import { HttpRequest } from '../../api.js';
import store from '../../store.js';
import config from '../../config.js';
import Vue from 'vue';
import _ from 'lodash';


export default{
    props: {
    },
    created(){
    },
    data: function(){
      return {
        layout: {
            'first_name': 'First Name',
            'last_name': 'Last Name',
            'username': 'Username',
        },
        passwordLayout: {
            'old_password': 'Old Password',
            'password': 'Password',
            'confirm_password': 'Confirm Password',
            'email': 'Email'
        },
        model: {
            'first_name': '',
            'last_name': '',
            'username': '',
            'password': '',
            'confirm_password': '',
            'email': '',
            'old_password': ''
        }
      };
    },
    computed: {
        user: function () {
            return store.state.user;
        }
    },

    methods: {
      toggleSidebar(){
        bus.$emit('toggle-sidebar');
      },

        update: async function () {
            let fields = Object.keys(this.model).length
            this.model['old_email'] = this.user['email'];
            let httpRequest = new HttpRequest();
            let isBlank = 0;
            for (var key in this.model) {
                // check if the property/key is defined in the object itself, not in parent
                if (this.model.hasOwnProperty(key)) {
                    if (this.model[key] == '') {
                        isBlank++;
                         console.log(isBlank);
                    }
                }
            }
            if (isBlank == fields) {
                this.showNotification('warning', 'You need to provide values to update the profile with. ')
            }else{
                if (this.model.password == this.model.confirm_password) {
                    let response = await httpRequest.sendRequest('post', `${config.baseAuthURL}update-user/`, this.model);
                    if (response !== null) {
                        this.showNotification('success', 'Profile updated successfully.');
                        window.setTimeout(function(){
                          location.reload();
                        }, 2000);
                    }else {
                        this.showNotification('danger', 'Could not update user, ensure that the old password entered is correct.')
                    }
                }else{
                    this.showNotification('danger', 'The passwords you entered did not match!')
                }
            }
            delete this.model['old_email'];

        },
        showNotification (type, content) {
            this.$notify({
              type: type,
              content: content
            });
        },
        enable: function (key) {
            if(key !== 'email') $(`#${key}`).prop('disabled', false);
        },
        getData: function (field) {
            if (this.user !== undefined) {
                return this.user[field] === undefined ? '' : this.user[field];
            }else{
                return '';
            }
        },
        isDisabled: function (key) {
            return key === 'email' ? true : false;
        }
    },

    mounted() {
      this.toggleSidebar();
    },

    components: {
    }
};
</script>

<style scoped lang="scss">
input, textarea, select { outline: none; border: none; }
button, button:active, button:focus {outline: none}
input:not([disabled]):active,
input:not([disabled]):focus,
input:not([disabled]) {
  width:100%;
  border-bottom: 1px solid #c3c3c3;
}

h1.detail-title{
  background-color: #04bafc;
  padding: 20px;
  margin-left: -40px;
  margin-right: -40px;
  color: white;
  height: auto;
  margin-bottom: 25px;

  i {
    cursor: pointer;
    display: none;
    font-size: 1.1em;
    margin-top: -4px;
    vertical-align: middle;
    text-shadow:  0px 1px 1px rgba(0, 0, 0, 0.1);

    &:hover {
      color: #f1f1f1;
    }
  }
}

.section-body { display: flex; flex-wrap: wrap; }
.card-section {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.section-property-block {
  margin-right: 16px;
    margin-bottom: 16px;
    // min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: gray;
    text-transform: uppercase;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 14px;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    width: 100%;
    font-size: 14px;
}
.section-title {
    color: #565656;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 24px;
}
.profile-container {
    // margin-top:20px;
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  h1.detail-title{
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px;  }
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  h1.detail-title{
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue